import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ValidatorService } from '../../core/services/validator.service';
import { GenderIcon, PersonService } from '../../core/services/person.service';
import { PersonState } from '../../core/states/offer/offer.state';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from '../../core/utils/typeUtils';
import { first } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GenderOrPrenatal } from '../../core/api';
import { PersonalDataFormGroup } from './personal-data.forms';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDataComponent implements OnInit {
  @Input() public person: PersonState;
  @Input() public formGroup: PersonalDataFormGroup;
  @Input() public validateForm: boolean = false;

  constructor(
    public validatorService: ValidatorService,
    private personService: PersonService,
  ) {}

  public ngOnInit(): void {
    if (
      this.person.details.genderOrPrenatal === GenderOrPrenatal.Prenatal &&
      isNullOrUndefined(this.person.details.firstName)
    ) {
      this.personService
        .createFirstNameFallback$(this.person.personId)
        .pipe(first(), untilDestroyed(this))
        .subscribe((firstNamePlaceholder) =>
          this.formGroup.patchValue({
            firstName: firstNamePlaceholder,
          }),
        );
    }
  }

  public getFirstNameOrFallback$(): Observable<string> {
    return this.personService.getFirstNameOrFallback$(this.formGroup.value.firstName, this.person.personId);
  }

  public getIcon$(): Observable<GenderIcon> {
    return this.personService.getIconForGender$(this.person.details.genderOrPrenatal, this.person.details.dateOfBirth);
  }
}
